"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _LockedFeatureBanner = _interopRequireDefault(require("ui-addon-upgrades/_core/lockedFeature/LockedFeatureBanner"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _appNames = require("ui-addon-upgrades/_core/common/constants/appNames");

var _getTitleStringKey = function _getTitleStringKey(app) {
  var titleStringKeySuffix = _appNames.AppToFeatureStringKey[app] || 'placeholder';
  return "upgrades.removeBrandingBanner.titles." + titleStringKeySuffix;
};

var RemoveBrandingBanner = function RemoveBrandingBanner(props) {
  var app = props.upgradeData.app;

  var title = _react.default.createElement(_FormattedMessage.default, {
    message: _getTitleStringKey(app)
  });

  return _react.default.createElement(_LockedFeatureBanner.default, (0, _extends2.default)({
    titleText: title,
    modalTitle: title,
    modalBodyText: _react.default.createElement(_FormattedMessage.default, {
      message: "upgrades.removeBrandingBanner.text"
    })
  }, props));
};

RemoveBrandingBanner.propTypes = {
  upgradeData: _react.default.PropTypes.shape({
    app: _react.default.PropTypes.string.isRequired
  })
};
var _default = RemoveBrandingBanner;
exports.default = _default;
module.exports = exports.default;